import type { RootState } from '@/store/root-reducer';

export const selectPrefs = (state: RootState) => state.notificationPreferences.prefs;
